// Servicio de tiendas
import { apiClient } from './api';
import { API_ENDPOINTS } from '../config';

export const storesService = {
  /**
   * Obtener todas las tiendas con filtros opcionales
   * @param {Object} filters - Filtros opcionales: { participating, featured, category }
   * @returns {Promise<Array>} Lista de tiendas
   */
  async getStores(filters = {}) {
    try {
      const response = await apiClient.get(API_ENDPOINTS.STORES, filters);
      return response.data || [];
    } catch (error) {
      console.error('Error fetching stores:', error);
      return [];
    }
  },

  /**
   * Obtener todas las tiendas (alias para compatibilidad)
   * @returns {Promise<Object>} Respuesta con lista de tiendas
   */
  async getAll() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.STORES);
      return {
        success: true,
        data: response.data || response || [],
      };
    } catch (error) {
      console.error('Error fetching stores:', error);
      return {
        success: false,
        data: [],
        error: error.message,
      };
    }
  },

  /**
   * Obtener tiendas participantes
   * @returns {Promise<Array>} Lista de tiendas participantes
   */
  async getParticipatingStores() {
    return this.getStores({ participating: true });
  },

  /**
   * Obtener tiendas destacadas
   * @returns {Promise<Array>} Lista de tiendas destacadas
   */
  async getFeaturedStores() {
    return this.getStores({ featured: true });
  },

  /**
   * Obtener tienda por ID
   * @param {string} id - ID de la tienda
   * @returns {Promise<Object|null>} Tienda o null si no se encuentra
   */
  async getStoreById(id) {
    try {
      const stores = await this.getStores();
      return stores.find(store => store.id === id) || null;
    } catch (error) {
      console.error('Error fetching store by id:', error);
      return null;
    }
  },
};

